<script lang="ts">
    import { SwitchBarApp } from './SwitchBarApp';

    export let switchBarApp: SwitchBarApp | null = null;
    export let onChange: (id: string[]) => void = () => {};

    let lastSelectedItems: string[] = [];

    if (switchBarApp === null) {
        switchBarApp = new SwitchBarApp();
        switchBarApp.setItems([
            { id: 'item1', label: 'Item 1' },
            { id: 'item2', label: 'Item 2' },
            { id: 'item3', label: 'Item 3' },
        ]);
        switchBarApp.selectItems(['item3']);
        switchBarApp = switchBarApp;
    }

    lastSelectedItems = switchBarApp.getSelectedItems();
</script>

<div class="switch-bar-container" data-selected-item={switchBarApp?.getSelectedItems()}>
    {#if switchBarApp}
        {#each switchBarApp.getItems() as item}
            <div
                on:click={() => {
                    if (switchBarApp) {
                        switchBarApp.selectItem(item.id);
                        switchBarApp = switchBarApp;
                        if (
                            JSON.stringify(lastSelectedItems) !==
                            JSON.stringify(switchBarApp.getSelectedItems())
                        ) {
                            onChange(switchBarApp.getSelectedItems());
                        }
                        lastSelectedItems = switchBarApp.getSelectedItems();
                    }
                }}
                class="switch-bar-item"
                class:active={switchBarApp.isItemSelected(item.id)}
            >
                {item.label}
            </div>
        {/each}
    {/if}
</div>

<style>
    .switch-bar-container {
        user-select: none;
        /*font-size: var(--font-size-tactical-plan);*/
        display: flex;
        justify-content: space-around;
        border-radius: 5px;
        column-gap: 1px;
        border: 2px solid #00000033;
        background-color: var(--analytics-gray-light);
    }
    .switch-bar-item {
        padding: 6px 6px;
        cursor: pointer;
        /*border-radius: 3px;*/
        background-color: white;
        flex: 1 0 auto;
        text-align: center;
    }
    .switch-bar-item.active {
        background-color: #6c6b6a;
        color: white;
    }
    .switch-bar-item:first-of-type {
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
    }
    .switch-bar-item:last-child {
        border-top-right-radius: 3px;
        border-bottom-right-radius: 3px;
    }
</style>
